import React, { useState } from "react";
import { toast } from "react-toastify";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ApiService from "../services/ApiService";
import logo from "../assets/img/mse-logo.webp";
import Footer from "../components/Footer/Footer";
import OtpInput from 'react-otp-input';
        
const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [isLoader, setIsLoader] = useState(false);
  const [otp, setOTP] = useState(searchParams.get('otp') || '');

  const userId = searchParams.get('user_id');


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: "POST",
        url: `verifyEmail`,
        data: {otp, user_id:userId},
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        let user = data.data.user;
        user.auth_token = data.data.auth_token;
        localStorage.setItem("user", JSON.stringify(data.data.user));
        window.location.href = "/dashboard";
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      toast.error("VerifyEmail failed!");
      setIsLoader(false);
    }
  };

  return (
    <>
      <div className="topbar-border">
        <div className="nav-logo px-3 py-2">
          <img src={logo} alt="UCAT Logo" />
        </div>
      </div>

      <Container fluid className="mt-3 p-0 signIn-form">
        <div className="text-center header">
          <h1 className="fw-light pb-3">MSE</h1>
        </div>

        <Row className="justify-content-center">
          <Col md={8} className="p-4">
            <h4 className="mb-3">Verify Email Address</h4>
            <p>
              We have sen't otp to your email enter here to make your active and enjoy our services.
            </p>
            <p>
              Please do not share that email with anyone. <br />
            </p>
          </Col>
          <Col md={5} className="signIn-form">
            <Card className="p-4">
              <h5 className="fw-light mb-4">
                Enter OTP:
              </h5>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="username" className="mb-3">
                  <Form.Label>* OTP:</Form.Label>
                  <OtpInput
                      value={otp}
                      onChange={(value) => setOTP(value)}
                      numInputs={4}
                      separator={<span>-</span>}
                      renderInput={(props) => <input {...props} style={{ width:'50px',margin:'10px', borderRadius:'5px', border: '1px solid #ccc', padding: '8px', fontSize: '18px', textAlign:'center' }} />}
                  />
                </Form.Group>


                <Button type="submit" className="w-50 form-btn"   disabled={isLoader}>
                  Verify Email
                  {isLoader &&  <div class="spinner-border spinner-border-sm mx-2" role="status">    </div> } 
                </Button>
              </Form>

           
            </Card>
          </Col>

          <Col md={3} className="mt-4 mt-md-0">
            <Card className="p-4">
              <h5>Already, have an account:</h5>
              <Link to={"/login"} className="w-50 create-acc">
                Login
              </Link>
            </Card>
          </Col>
        </Row>

        <Footer />
      </Container>
    </>
  );
};

export default VerifyEmail;
